<script>
/**
 * ****************************************************************************
 * @description     :   Component for show error in Header
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   STworks
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import libraries
 */
import { mapState, mapMutations } from 'vuex';

/**
 * Import template
 */
import template from './template.html';

/**
 * Define component chat for show page chat
 */
var HeaderError = {
    template: template,
    data() {
        return {
            havePopup: false
        };
    },
    methods: {
        ...mapMutations('app', ['hideHeaderError'])
    },
    watch: {
        isShowHeaderError(newVal) {
            if (newVal) {
                const collection =
                    document.getElementsByClassName('modal show');
                if (collection.length > 0) {
                    this.havePopup = true;
                } else {
                    this.havePopup = false;
                }
            } else {
                this.havePopup = false;
            }
        }
    },
    computed: {
        ...mapState('app', ['isShowHeaderError', 'headerErrors', 'isMobile'])
    }
};
export default HeaderError;
</script>
